import React from 'react';
import {Card, CardHeader, CardBody, CardFooter, Button} from 'reactstrap';
import ApiConfig from "../../constants/ApiConfig";
import * as mediaService from "../../services/media";
import * as sessionService from "../../services/session";

class WhFinder extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            data : this.props.initialValues[this.props.name]

        }

        this.remove = this.remove.bind(this);
        this.openMediaBox = this.openMediaBox.bind(this);
        this.onImgChange = this.onImgChange.bind(this);



    }


    openMediaBox (id) {

        let token = sessionService.getToken();

        let params = {
            access_token    : `${token.access_token}`,
            type            : 'api',
            url             : ApiConfig.finderParams.url,
            endPointMedia   : ApiConfig.finderParams.endPointMedia,
            assetUrl        : ApiConfig.finderParams.assetUrl
        };

        let str = '';
        for (let key in params) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(params[key]);
        }


        const url = `/wh-finder/index.html?${str}#/?id=${id}`;

        window.open(url,"wh media center","location=no, menubar=no, status=no, scrollbars=no, menubar=no, width=800, height=600");

    };

    onImgChange (data) {

        let val = data.target.value;


        mediaService.search({filtered : [{id : 'url', value : val}]}).then((data) => {

            data = data['hydra:member'][0];

            this.props.change(this.props.name, data);
            this.setState({data});


        });


    };

    uniqid () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    remove() {

        this.setState({data : {}});
        this.props.change(this.props.name, null);

    }

    render() {


        const {data} = this.state;

        let myId = (this.props.id) ? this.props.id : `media${this.uniqid()}`;

        return (

            <Card>
                <CardHeader>
                    <i className="fa fa-image"></i> {this.props.title}
                    <div className="card-actions">
                        <a href={`javascript:void(0);`} onClick={() => this.remove()}><i className={'fa fa-trash'}></i></a>
                    </div>

                </CardHeader>


                <CardBody>
                {
                    data &&
                    data.url &&
                    data.type == 'image' &&
                    <img src={mediaService.getAsset(data)} style={{maxWidth:'100%'}} />
                }
                </CardBody>


                <CardFooter>
                    <input type="text" id={myId} onChange={(event) => this.onImgChange(event)} style={{position : 'absolute', left : '-90000px'}} />
                    <Button color={'success'} block onClick={() => this.openMediaBox(myId)}>Media</Button>
                </CardFooter>

            </Card>


        );

    }

};


export default WhFinder




// WEBPACK FOOTER //
// ./src/components/Form/wh-finder.js